export default __webpack_public_path__ + "static/media/ally_background_s2.1a8af442.jpg";